module.exports = __webpack_public_path__ + "static/tools-resources-waye-day-photo-feebc045a39971a9fe7c57ae05729fec.jpg";